// Principals shown on the site (spec c.7 §5). Founder decision 2026-10-09:
// exactly Raul and Efrén. Copy (name, role, bio, industries) lives in i18n `team.<key>.*`;
// every number shown for a principal comes from `years` below.

export type TeamKey = "raul" | "efren";

export type Principal = {
  key: TeamKey;
  initials: string;
  /** Years of SAP experience; feeds `combinedYears` and the "{{n}}+ years in SAP" line. */
  years: number;
  /** SAP module codes shown as chips (max 6; we show 5). */
  codes: string[];
  /** Risk can hide a principal without a layout change. */
  visible: boolean;
  /** Optional portrait (WebP 400×400, ≤ 40 KB); replaces the monogram. */
  photo?: string;
};

export const team: Principal[] = [
  {
    key: "raul",
    initials: "RG",
    years: 30,
    codes: ["S/4HANA", "FICO", "PM", "HCM", "SuccessFactors"],
    visible: true,
  },
  {
    key: "efren",
    initials: "ES",
    years: 12,
    codes: ["EWM", "MM", "SD", "TM", "MII"],
    visible: true,
  },
];

export const visibleTeam = (members: Principal[] = team): Principal[] =>
  members.filter((m) => m.visible);

/**
 * Combined SAP years of the visible principals, floored to the decade
 * (30 + 12 = 42 → 40). Pass to i18n as `{{years}}` and render as "{{years}}+".
 */
export const combinedYears = (members: Principal[] = team): number =>
  Math.floor(visibleTeam(members).reduce((sum, m) => sum + m.years, 0) / 10) * 10;
